<yc-modal *ngIf="body"
  [modalHeader]="'GLOBAL:hdrEmailPreview' | ycI18n: 'Email Preview'"
  [modalSubHeader]="email.subject"
  [primaryButtonText]="'common:textClose' | ycI18n"
  [secondaryButtonText]="editEmailsArea && email.active ?
    ('GLOBAL:textSendTestEmail' | ycI18n: 'Send test email') :
    ''"
  (onSecondaryClick)="sendTest()"
  (onPrimaryClick)="onCancel()">
  
  <div *ngIf="showEmailHeader">
    <ng-container *ngIf="hasInternational && editEmailsArea && email.id">
      <div [formGroup]="formGroup" 
        class="form-group mb-3">
        <yc-typeahead-select
          [items]="languageOptions"
          [label]="'GLOBAL:lblLanguage' | ycI18n: 'Language'"
          name="translationLanguage"
          (onChange)="languageOptionChange($event)">
        </yc-typeahead-select>
      </div>
    </ng-container>
  
    <gc-email-header-block
      [title]="email.title || email.subject">
    </gc-email-header-block>
  </div>

  <div [innerHTML]="body | escapeHtml"
    [class.email-container]="!removeEmailContainerClass">
  </div>

</yc-modal>
